export const mainArea = {
  city: "春日部市",
  text: "春日部市を中心に、会社から近い地域のお客様を大切にした地域密着型のサービスです。",
};

export const neighborAreas = [
  "越谷市",
  "さいたま市",
  "草加市",
  "八潮市",
  "三郷市",
  "吉川市",
  "川口市",
  "松伏町",
  "杉戸町",
  "宮代町",
  "幸手市",
  "久喜市",
  "蓮田市",
  "白岡市",
  "上尾市",
];

export const areaNote =
  "上記エリア以外についても、まずはご相談ください。遠方の場合は事前相談とさせていただきます。";